<div class="reward-info-root">
  <header>
    <div>
      <h1>{{ data.reward.name }}</h1>
      <button id="close-dialog-icon" (click)="onDialogClose()" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <h2>{{ descriptionLabel | transloco }}</h2>
  </header>
  <div class="reward-info-content">
    <app-reward-card
      [reward]="reward"
      (closeDialog)="onDialogClose(false)"
      [isInfoModal]="true"
      [deleteHandler]="this.data.deleteHandler"
      [availableFamilies]="data.availableFamilies"
      [availableBusinessLevels]="data.availableBusinessLevels"
    ></app-reward-card>
    <app-reward-info 
      [data]="rewardInfoData"
      [availableFamilies]="data.availableFamilies"
      [availableBusinessLevels]="data.availableBusinessLevels"
    ></app-reward-info>
  </div>
</div>
